<template>
  <TaskList
    title="Compare Documents"
    taskType="compare_doc"
  >
  </TaskList>
</template>

<script>
import TaskList from '@/components/TaskList.vue';

export default {
  components: {
    TaskList
  },
}
</script>
